import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  WarningFilled,
} from '@ant-design/icons'
import type { BreadcrumbItemType } from 'antd/es/breadcrumb/Breadcrumb'
import { ReactComponent as Logo } from 'assets/svg/logo.svg'
import cls from 'classnames'
import LazyComponent from 'components/LazyComponent'
import { useCssInJs } from 'hooks/useCssInJs'
import React, {
  PropsWithChildren,
  useContext,
  useEffect,
  useState,
} from 'react'
import { isProdEnv } from '@micun/web-components/dist/utils/common'
import ENV from '@micun/web-components/dist/components/Layout/EnvNew'
import { Menu } from './Menu'
import { genLayoutStyle } from './styles'
import { UserInfo } from './user'

type AppConfig = {
  appCode: string
}

type TLayoutContext = {
  config: AppConfig
  collapsed?: boolean
  setCollapsed?: (
    collapsed: boolean | ((collapsed: boolean) => boolean)
  ) => void
  baseBreadcrumb?: BreadcrumbItemType[]
  setBaseBreadcrumb?: (
    items:
      | BreadcrumbItemType[]
      | ((items: BreadcrumbItemType[]) => BreadcrumbItemType[])
  ) => void
  breadcrumb?: BreadcrumbItemType[]
  setBreadcrumb?: (
    items:
      | BreadcrumbItemType[]
      | ((items: BreadcrumbItemType[]) => BreadcrumbItemType[])
  ) => void
}

export const LayoutContext = React.createContext<TLayoutContext>(null!)

export function useLayout() {
  return useContext(LayoutContext)
}

export function LayoutProvider(props: TLayoutContext & PropsWithChildren) {
  const { children, config } = props
  const [collapsed, setCollapsed] = useState(
    localStorage['collapsed'] === 'true' || false
  )
  const [baseBreadcrumb, setBaseBreadcrumb] = useState([])
  const [breadcrumb, setBreadcrumb] = useState([])

  useEffect(() => {
    localStorage['collapsed'] = collapsed
  }, [collapsed])
  return (
    <LayoutContext.Provider
      value={{
        config,
        collapsed,
        setCollapsed,
        breadcrumb,
        setBreadcrumb,
        baseBreadcrumb,
        setBaseBreadcrumb,
      }}
    >
      {children}
    </LayoutContext.Provider>
  )
}

export function Layout(props: PropsWithChildren) {
  const { children } = props
  const { collapsed, setCollapsed } = useLayout()
  const prefix = 'layout'
  const { wrapSSR, hashId } = useCssInJs({
    prefix: 'layout',
    styleFun: genLayoutStyle,
  })

  /* const finalBreadcrumb = useMemo(() => {
    return [...baseBreadcrumb, ...breadcrumb]
  }, [baseBreadcrumb, breadcrumb]) */

  return wrapSSR(
    <div className={cls(prefix, hashId, collapsed ? 'collapsed' : '')}>
      <div className='slider'>
        <div className='logo'>
          <h1>
            <Logo className='svg' />
            <span>米村伙伴协同平台</span>
          </h1>
        </div>
        <div className='menu'>
          <Menu />
        </div>
      </div>
      <div className='layout'>
        <div className='header'>
          <div className='tools'>
            <div
              onClick={() => setCollapsed((v) => !v)}
              className='button-collapse'
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </div>
            {isProdEnv ? (
              <div className='global-tips'>
                <WarningFilled />
                <span>当前为正式环境，请谨慎操作</span>
              </div>
            ) : null}
            <div className='userinfo'>
              <ENV />
              <UserInfo />
            </div>
          </div>
          {/* {finalBreadcrumb.length ? (
            <Breadcrumb className='breadcrumb' items={finalBreadcrumb} />
          ) : (
            <div className='breadcrumb' />
          )} */}
          {/* <div className='breadcrumb' /> */}
        </div>
        <div className='content'>
          <LazyComponent>{children}</LazyComponent>
        </div>
      </div>
    </div>
  )
}
